import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../config/firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from 'firebase/firestore';
import "./PageHeader.css";
import LoadingScreen from "./LoadingScreen";

interface Props {
  pageTitle: string,
}

const PageHeader: React.FC<Props> = ({ pageTitle }) => {

  const [user, loading] = useAuthState(auth as any);
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const groupID = localStorage.getItem("group");
  const courseID = localStorage.getItem("course");

  const [queryParameters, setQueryParameters] = useState(null)

  useEffect(() => {
    let tempQuery = new URLSearchParams(window.location.search);
    if (tempQuery) {
      setQueryParameters(new URLSearchParams(window.location.search));
    }
  }, [])

  const [appMode, setAppMode] = useState(false);

  useEffect(() => {
    if (queryParameters) {
      let tempAppMode = queryParameters.get("appMode");
      if (tempAppMode) {
        setAppMode(true);
      }
    }
  }, [queryParameters]);

  useEffect(() => {
    const getCourseData = async () => {
      try {
        const courseRef = doc(db, 'groups', groupID, 'courses', courseID);
        const courseDoc = await getDoc(courseRef);
        if (courseDoc.exists()) {
          setCourse(courseDoc.data());
        }
      } catch (err) {
        console.error("Error: ", err);
      }
    };

    if (groupID && courseID) {
      getCourseData();
    }
  }, [courseID, groupID]);

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/", { replace: true });
  }, [user, loading, navigate]);

  return (
    <>
      {!appMode &&
        <div className="pageHeader">
          {loading && <LoadingScreen />}

          {course?.name}<br></br><small className="mt-2 d-block text-secondary">{pageTitle}</small>
        </div>
      }
    </>
  );
}

export default PageHeader;
